import { parseCookies } from '@cian/utils/lib/shared/cookie';

export interface ITeaserEventProps {
  soprApi: string;
  user_id: string | null;
  position: number | null;
  pageType: string;
  device_type: string;
  ab_group: string | null;
  block_type: string;
  isTeaserShow: 1 | 0;
}

export const getViewportHeight = () => Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
export const getViewportWidth = () => Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

export function sendTeaserEvent(events: Array<ITeaserEventProps>) {
  const viewport = {
    width: getViewportWidth(),
    height: getViewportHeight(),
  };
  const cid = parseCookies(document.cookie)['_CIAN_GK'];

  const firstEvent = events[0];
  const { soprApi, user_id, ab_group, pageType, device_type } = firstEvent;
  fetch(`${soprApi}teaser/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      user_id,
      device_type,
      viewport,
      ab_group,
      cid,
      pageType,
      items: events.map(({ soprApi, user_id, ab_group, pageType, device_type, ...props }) => props),
    }),
  });
}
